/**
 * WordPress dependencies
 */

export default {
	hookPrefix: 'team',
};
